'use client';

;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { PrismicNextImage } from '@prismicio/next';
import { EmblaCarouselType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import React, { useCallback, useEffect, useState } from 'react';
import { PrevButton, NextButton, usePrevNextButtons } from './ArrowButtons';
import { TestimonialsCarouselProps } from './types';
const TestimonialsCarousel: React.FC<TestimonialsCarouselProps> = ({
  slides
}) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [autoPlayProgress, setAutoPlayProgress] = useState(0);
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    watchDrag: slides.length > 1
  });
  const onNavButtonClick = useCallback((emblaApi: EmblaCarouselType) => {
    // reset autoplay progress
    setAutoPlayProgress(0);
    const currentIndex = emblaApi.selectedScrollSnap();
    setCurrentSlideIndex(currentIndex);
  }, []);
  const {
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi, onNavButtonClick);
  useEffect(() => {
    if (slides.length < 2) return;
    const interval = setInterval(() => {
      if (emblaApi) {
        // check if autoplay progress is 100%
        if (autoPlayProgress >= 100) {
          emblaApi.scrollNext();
          const currentIndex = emblaApi.selectedScrollSnap();
          setAutoPlayProgress(0);
          setCurrentSlideIndex(currentIndex);
        } else {
          // increment autoplay progress by 2%
          setAutoPlayProgress(currentValue => currentValue + 2);
        }
      }
      // autoplay every 5 seconds
    }, 200);
    return () => clearInterval(interval);
  }, [autoPlayProgress, emblaApi, slides.length]);
  return <section className="relative m-auto max-w-140" data-sentry-component="TestimonialsCarousel" data-sentry-source-file="index.tsx">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="-ml-4 flex min-h-90 touch-pan-y backface-hidden md:min-h-75">
          {slides.map(({
          name,
          avatar,
          comment,
          profession,
          title
        }) => <div className="flex w-full min-w-0 shrink-0 grow-0 basis-full flex-col pl-4" key={name}>
              <p className="text-caption-1 text-primary-600 mb-7 font-bold lg:mb-9">{title}</p>
              <span className="text-body-6 lg:text-body-4 mb-4 line-clamp-6 font-medium md:line-clamp-4">
                {comment}
              </span>
              <div className="mt-auto mb-22 flex flex-row md:mb-0">
                <PrismicNextImage fallbackAlt="" field={avatar} width={56} height={56} className="mr-4 rounded-full" />
                <div className="flex h-14 flex-col justify-center">
                  <span className="text-h8 mb-1 font-bold text-gray-600">{name}</span>
                  <span className="text-caption-2 font-medium text-gray-400">{profession}</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      {slides.length > 1 && <div className="absolute bottom-0 left-0 flex h-14 flex-row items-center gap-3 md:right-0 md:left-auto">
          <PrevButton onClick={onPrevButtonClick} />
          <span className="text-menu flex w-9.5 items-center justify-center font-medium text-gray-400">
            {currentSlideIndex + 1}/{slides.length}
          </span>
          <NextButton onClick={onNextButtonClick} progress={autoPlayProgress} />
        </div>}
    </section>;
};
export default TestimonialsCarousel;